export class Adapter {
    private static value: unknown[];

    static from<Source>(originalData: Source | Source[]) {
        if (Array.isArray(originalData)) {
            this.value = originalData;
        } else {
            this.value = [originalData];
        }
        return this;
    }

    public static to<Input, Output>(map: (value: Input) => Output) {
        const transformed = (this.value as Input[]).map(map);
        return transformed;
    }
}